export const DATE_ORDER_ERROR =
  'Prior Period dates must come before Current Period dates. Dates must be in ascending order.';

export const FORMAT_ERROR = 'Enter a valid date in MM/YYYY format. Fields cannot be empty.';

export const DATE_OPTION_ERROR = 'The selected date is not valid. Please choose a date from the available options.';

export const PERSON_ID_CHARACTER_LIMIT_ERROR = 'Character limit exceeded. Maximum allowed is 5,000,000 characters.';

export const PERSON_ID_FORMAT_ERROR = 'Input must be separated by commas, semicolons, or line breaks.';
